class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItem = this.closest('[data-cart-item]');
        if (cartItem) {
          cartItem.classList.add('opacity-40', 'pointer-events-none', 'transition-opacity', 'duration-300');
        }
        const cartItems = this.closest('cart-items') || this.closest('cart-flyover-items');
        cartItems.updateQuantity(this.dataset.index, 0, event);
      });
    }
  }
  
  if (!customElements.get('cart-remove-button')) {
    customElements.define('cart-remove-button', CartRemoveButton);
  }
  
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartFlyover-LineItemStatus');
  
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);
  
      this.addEventListener('change', debouncedOnChange.bind(this));
    }
  
    cartUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        return this.onCartUpdate();
      });
    }
  
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  
    resetQuantityInput(id) {
      const input = this.querySelector(`#Quantity-${id}`);
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  
    setValidity(event, index, message) {
      event.target.setCustomValidity(message);
      event.target.reportValidity();
      this.resetQuantityInput(index);
      event.target.select();
    }
  
    validateQuantity(event) {
      const inputValue = parseInt(event.target.value);
      const index = event.target.dataset.index;
      let message = '';
  
      if (inputValue < event.target.dataset.min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
      } else if (inputValue > parseInt(event.target.max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
      } else if (inputValue % parseInt(event.target.step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
      }
  
      if (message) {
        this.setValidity(event, index, message);
      } else {
        event.target.setCustomValidity('');
        event.target.reportValidity();
        this.updateQuantity(
          index,
          inputValue,
          event,
          document.activeElement.getAttribute('name'),
          event.target.dataset.quantityVariantId
        );
      }
    }
  
    onChange(event) {
      this.validateQuantity(event);
    }
  
    onCartUpdate() {
      if (this.tagName === 'CART-FLYOVER-ITEMS') {
        return fetch(`${routes.cart_url}?section_id=cart-flyover`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-flyover-items', '.cart-flyover__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        return fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-count',
          section: 'cart-icon-count',
          selector: '.cart-count-badge',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: 'main-cart-footer',
          selector: '.shopify-section',
        },
      ];
    }
  
    updateQuantity(line, quantity, event, name, variantId) {
      this.enableLoading(line);
  
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
  
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
  
          CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {

            const quantityElement =
              document.getElementById(`Quantity-${line}`) || document.getElementById(`Flyover-quantity-${line}`);
            const items = document.querySelectorAll('.cart-item');
  
            if (parsedState.errors) {

              quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }
  
  
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFlyoverWrapper = document.querySelector('cart-flyover');
            const cartFooter = document.getElementById('main-cart-footer');
            
            // Toggle main cart sections visibility
            const cartItemsGrid = document.getElementById('cart-items-grid');
            const cartEmptyState = document.getElementById('cart-empty-state');
            
            if (cartItemsGrid && cartEmptyState) {
              if (parsedState.item_count === 0) {
                cartItemsGrid.classList.add('hidden');
                cartItemsGrid.classList.remove('grid');
                cartEmptyState.classList.add('block');
                cartEmptyState.classList.remove('hidden');
              } else {
                cartItemsGrid.classList.add('grid');
                cartItemsGrid.classList.remove('hidden');
                cartEmptyState.classList.add('hidden');
                cartEmptyState.classList.remove('block');
              }
            }
         
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

            if (parsedState.item_count === 0) {
              this.classList.add('opacity-0');
              setTimeout(() => {
                this.classList.remove('opacity-0');
              }, 320);
            }

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            window.updateSubmenuHeight();
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(line, message);
  
            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartFlyover-Item-${line}`);

            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartFlyoverWrapper
                ? trapFocus(cartFlyoverWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartFlyoverWrapper) {
              trapFocus(cartFlyoverWrapper.querySelector('.Flyover__inner-empty'), cartFlyoverWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartFlyoverWrapper) {
              trapFocus(cartFlyoverWrapper, document.querySelector('.cart-item__name'));
            }
          });
  
          CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch((error) => {
          console.error("cart update error", error);
          const errors = document.getElementById('cart-errors');
          const errorsText = document.getElementById('cart-errors-text');
          errors.classList.remove('hidden');
          errors.classList.add('flex');
          errorsText.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }
    
    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartFlyover-LineItemError-${line}`);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
  
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartFlyover-LiveRegionText');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    enableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartFlyover-CartItems');
      mainCartItems.classList.add('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartFlyoverItemElements = this.querySelectorAll(`#CartFlyover-Item-${line} .loading__spinner`);
  
      [...cartItemElements, ...cartFlyoverItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  
    disableLoading(line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartFlyover-CartItems');
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartFlyoverItemElements = this.querySelectorAll(`#CartFlyover-Item-${line} .loading__spinner`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartFlyoverItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }
  }
  
  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }
  
